import React, { Component } from "react";

export default class Header extends Component {
  render() {
    return (
      <nav
        id="site-navigation"
        className="main-navigation top-bar"
        role="navigation"
      >
        <div className="top-bar-left">
          <ul
            className="menu"
            data-dropdown-menu="kopi6o-dropdown-menu"
            role="menubar"
          >
            <li className="home" role="menuitem">
              <a
                href="https://www.skodalaagri.ee/"
                rel="home"
                className="skodalaagriLogo"
              >
                <img
                  src="https://www.skodalaagri.ee/sko/wp-content/themes/skodalaagri2017/assets/images/skoda_laagri_logo.svg"
                  alt="Skoda Laagri"
                />
              </a>
            </li>

            <li
              id="menu-item-666"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-3840 is-dropdown-submenu-parent opens-right models-menu-item"
              role="menuitem"
              aria-haspopup="true"
              aria-label="Mudelid"
              data-is-click="false"
            >
              <a href="#">Mudelid</a>

              <span className="menujoon"></span>
            </li>
            <li
              id="menu-item-25963"
              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-25963"
              role="menuitem"
            >
              <a
                target="_blank"
                href="https://www.skoda.ee/vali-ja-osta/hinnakirjad-ja-kataloogid"
              >
                Hinnakirjad
              </a>
              <span className="menujoon"></span>
            </li>
            <li
              id="menu-item-24497"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-24497 is-dropdown-submenu-parent opens-right"
              role="menuitem"
              aria-haspopup="true"
              aria-label="Eripakkumised"
            >
              <a href="https://www.skodalaagri.ee/kampaania-laoautod/">
                Eripakkumised
              </a>
              <ul
                className="dropdown menu vertical  submenu is-dropdown-submenu first-sub"
                data-toggle=""
                data-submenu=""
                role="menu"
              >
                <li
                  id="menu-item-19089"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19089 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a href="https://www.skodalaagri.ee/kampaania-laoautod/">
                    Salongis kohe olemas
                  </a>
                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-25139"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-25139 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a href="https://cc.skoda-auto.com/est/et-EE/">
                    Pane kokku oma Škoda
                  </a>
                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-18339"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18339 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a target="_blank" href="https://laagri.skoda.ee/et/search?">
                    Laoautode pakkumised
                  </a>
                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-30075"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-30075 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a href="https://www.skodalaagri.ee/olemasolev-auto-sissemaksuks/">
                    Olemasolev auto sissemaksuks
                  </a>
                  <span className="menujoon"></span>
                </li>
              </ul>

              <span className="menujoon"></span>
            </li>
            <li
              id="menu-item-18343"
              className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-3815 current_page_item menu-item-18343 active"
              role="menuitem"
            >
              <a href="https://www.skodalaagri.ee/kasutatud-autod/">
                Kasutatud autod
              </a>
              <span className="menujoon"></span>
            </li>
            <li
              id="menu-item-29953"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-29953"
              role="menuitem"
            >
              <a href="https://www.skodalaagri.ee/kindlustus/">Kindlustus</a>
              <span className="menujoon"></span>
            </li>
            <li
              id="menu-item-37"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-37 is-dropdown-submenu-parent opens-right"
              role="menuitem"
              aria-haspopup="true"
              aria-label="Teenindus"
            >
              <a href="https://www.skodalaagri.ee/autohooldus-ja-remont/">
                Teenindus
              </a>
              <ul
                className="dropdown menu vertical  submenu is-dropdown-submenu first-sub"
                data-toggle=""
                data-submenu=""
                role="menu"
              >
                <li
                  id="menu-item-7983"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7983 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a href="https://www.skodalaagri.ee/autohooldus-ja-remont/">
                    Broneeri aeg
                  </a>
                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-19999"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-19999 is-dropdown-submenu-parent is-submenu-item is-dropdown-submenu-item opens-right"
                  role="menuitem"
                  aria-haspopup="true"
                  aria-label="Teeninduse kampaaniad"
                >
                  <a href="#">Teeninduse kampaaniad</a>
                  <ul
                    className="dropdown menu vertical  submenu is-dropdown-submenu"
                    data-toggle=""
                    data-submenu=""
                    role="menu"
                  >
                    <li
                      id="menu-item-24123"
                      className="menu-item menu-item-type-custom menu-item-object-custom menu-item-24123 is-submenu-item is-dropdown-submenu-item"
                      role="menuitem"
                    >
                      <a href="https://www.skodalaagri.ee/makseviisid/">
                        Maksa mitmes osas
                      </a>
                      <span className="menujoon"></span>
                    </li>{" "}
                  </ul>

                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-7984"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7984 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a href="https://www.skodalaagri.ee/teeninduse-hinnakiri/">
                    Hinnakiri
                  </a>
                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-19622"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-19622 is-dropdown-submenu-parent is-submenu-item is-dropdown-submenu-item opens-right"
                  role="menuitem"
                  aria-haspopup="true"
                  aria-label="Varuosad"
                >
                  <a href="#">Varuosad</a>
                  <ul
                    className="dropdown menu vertical  submenu is-dropdown-submenu"
                    data-toggle=""
                    data-submenu=""
                    role="menu"
                  >
                    <li
                      id="menu-item-19968"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19968 is-submenu-item is-dropdown-submenu-item"
                      role="menuitem"
                    >
                      <a href="https://www.skodalaagri.ee/varuosaparing/">
                        Varuosa päring
                      </a>
                      <span className="menujoon"></span>
                    </li>{" "}
                    <li
                      id="menu-item-19624"
                      className="menu-item menu-item-type-custom menu-item-object-custom menu-item-19624 is-submenu-item is-dropdown-submenu-item"
                      role="menuitem"
                    >
                      <a target="_blank" href="https://pood.skoda.ee/">
                        E-pood tarvikutele
                      </a>
                      <span className="menujoon"></span>
                    </li>{" "}
                  </ul>

                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-19511"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-19511 is-dropdown-submenu-parent is-submenu-item is-dropdown-submenu-item opens-right"
                  role="menuitem"
                  aria-haspopup="true"
                  aria-label="Keretööd"
                >
                  <a href="#">Keretööd</a>
                  <ul
                    className="dropdown menu vertical  submenu is-dropdown-submenu"
                    data-toggle=""
                    data-submenu=""
                    role="menu"
                  >
                    <li
                      id="menu-item-19512"
                      className="menu-item menu-item-type-custom menu-item-object-custom menu-item-19512 is-submenu-item is-dropdown-submenu-item"
                      role="menuitem"
                    >
                      <a
                        target="_blank"
                        href="https://damageinspection.cab.se/SkodaLaagri/#/booking/start"
                      >
                        Broneeri kahjude ülevaatus
                      </a>
                      <span className="menujoon"></span>
                    </li>{" "}
                  </ul>

                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-7985"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7985 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a href="https://www.skodalaagri.ee/rehvivahetus/">
                    Rehvivahetus
                  </a>
                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-19625"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19625 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a href="https://www.skodalaagri.ee/garantii/">Garantii</a>
                  <span className="menujoon"></span>
                </li>{" "}
                <li
                  id="menu-item-19377"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19377 is-submenu-item is-dropdown-submenu-item"
                  role="menuitem"
                >
                  <a href="https://www.skodalaagri.ee/rakendus-skoda-connect/">
                    ŠKODA Connect
                  </a>
                  <span className="menujoon"></span>
                </li>
              </ul>

              <span className="menujoon"></span>
            </li>
            <li
              id="menu-item-14008"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-14008"
              role="menuitem"
            >
              <a href="https://www.skodalaagri.ee/rent/">Autorent</a>
              <span className="menujoon"></span>
            </li>
            <li
              id="menu-item-29238"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-29238"
              role="menuitem"
            >
              <a href="https://www.skodalaagri.ee/arikliendile/">
                Ärikliendile
              </a>
              <span className="menujoon"></span>
            </li>
            <li
              id="menu-item-14395"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-14395"
              role="menuitem"
            >
              <a href="https://www.skodalaagri.ee/kontakt/">Kontaktid</a>
              <span className="menujoon"></span>
            </li>
          </ul>
        </div>
        <div className="top-bar-right">
          <nav className="vertical menu" id="mobile-menu" role="navigation">
            <ul
              id="menu-mobiil"
              className="vertical menu"
              data-accordion-menu="mex7y2-accordion-menu"
              data-options="multiOpen:false; clickOpen: true; disableHover: true;"
              role="tree"
              aria-multiselectable="false"
            >
              <li
                id="menu-item-18425"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18425 is-accordion-submenu-parent"
                role="treeitem"
                aria-controls="a2jvai-acc-menu"
                aria-expanded="false"
              >
                <a href="#">Eripakkumised</a>
                <ul
                  className="vertical nested menu submenu is-accordion-submenu"
           
           
                >
                  <li
                    id="menu-item-2979"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2979 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://www.skodalaagri.ee/kampaania-laoautod/">
                      Salongis kohe olemas
                    </a>
                  </li>{" "}
                  <li
                    id="menu-item-27841"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-27841 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://cc.skoda-auto.com/est/et-EE/">
                      Pane kokku oma Škoda
                    </a>
                  </li>{" "}
                  <li
                    id="menu-item-18423"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18423 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://laagri.skoda.ee/et/search?models=octavia">
                      Laoautode pakkumised
                    </a>
                  </li>{" "}
                  <li
                    id="menu-item-30076"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-30076 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://www.skodalaagri.ee/olemasolev-auto-sissemaksuks/">
                      Olemasolev auto sissemaksuks
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-2981"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2981"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/proovisoit/">Proovisõit</a>
              </li>
              <li
                id="menu-item-3841"
                className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-3815 current_page_item menu-item-3841 active"
                role="treeitem"
              >
                <a
                  href="https://www.skodalaagri.ee/kasutatud-autod/"
                  aria-current="page"
                >
                  Kasutatud autod
                </a>
              </li>
              <li
                id="menu-item-18422"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18422 is-accordion-submenu-parent"
                role="treeitem"
                aria-controls="rkfs9c-acc-menu"
                aria-expanded="false"
              >
                <a href="#">Teenindus</a>
                <ul
                  className="vertical nested menu submenu is-accordion-submenu"
             
                >
                  <li
                    id="menu-item-2982"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2982 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://www.skodalaagri.ee/autohooldus-ja-remont/">
                      Broneeri aeg
                    </a>
                  </li>{" "}
                  <li
                    id="menu-item-20004"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-20004 is-accordion-submenu-parent is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                    aria-controls="cixtbl-acc-menu"
                    aria-expanded="false"
                  >
                    <a href="#">Teeninduse kampaaniad</a>
                    <ul
                      className="vertical nested menu submenu is-accordion-submenu"
                
                    >
                      <li
                        id="menu-item-24158"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-24158 is-submenu-item is-accordion-submenu-item"
                        role="treeitem"
                      >
                        <a href="https://www.skodalaagri.ee/makseviisid/">
                          Maksa mitmes osas
                        </a>
                      </li>{" "}
                    </ul>
                  </li>{" "}
                  <li
                    id="menu-item-7987"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7987 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://www.skodalaagri.ee/teeninduse-hinnakiri/">
                      Hinnakiri
                    </a>
                  </li>{" "}
                  <li
                    id="menu-item-19629"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-19629 is-accordion-submenu-parent is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                    aria-controls="pkyff4-acc-menu"
                    aria-expanded="false"
                  >
                    <a href="#">Varuosad</a>
                    <ul
                      className="vertical nested menu submenu is-accordion-submenu"
                
                    >
                      <li
                        id="menu-item-19969"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19969 is-submenu-item is-accordion-submenu-item"
                        role="treeitem"
                      >
                        <a href="https://www.skodalaagri.ee/varuosaparing/">
                          Varuosa päring
                        </a>
                      </li>{" "}
                      <li
                        id="menu-item-19631"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-19631 is-submenu-item is-accordion-submenu-item"
                        role="treeitem"
                      >
                        <a href="https://pood.skoda.ee/">E-pood tarvikutele</a>
                      </li>{" "}
                    </ul>
                  </li>{" "}
                  <li
                    id="menu-item-19632"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-19632 is-accordion-submenu-parent is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                    aria-controls="2jhgbp-acc-menu"
                    aria-expanded="false"
                  >
                    <a href="#">Keretööd</a>
                    <ul
                      className="vertical nested menu submenu is-accordion-submenu"
                  
                    >
                      <li
                        id="menu-item-19633"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-19633 is-submenu-item is-accordion-submenu-item"
                        role="treeitem"
                      >
                        <a href="https://damageinspection.cab.se/SkodaLaagri/#/booking/start">
                          Broneeri kahjude ülevaatus
                        </a>
                      </li>{" "}
                    </ul>
                  </li>{" "}
                  <li
                    id="menu-item-7986"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7986 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://www.skodalaagri.ee/rehvivahetus/">
                      Rehvivahetus
                    </a>
                  </li>{" "}
                  <li
                    id="menu-item-19627"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19627 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://www.skodalaagri.ee/garantii/">Garantii</a>
                  </li>{" "}
                  <li
                    id="menu-item-19628"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19628 is-submenu-item is-accordion-submenu-item"
                    role="treeitem"
                  >
                    <a href="https://www.skodalaagri.ee/rakendus-skoda-connect/">
                      ŠKODA Connect
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-14372"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-14372"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/rent/">Autorent</a>
              </li>
              <li
                id="menu-item-2980"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2980"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/kontakt/">Kontaktid</a>
              </li>
              <li
                id="menu-item-24159"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-24159"
                role="treeitem"
              >
                <a href="https://cc.skoda-auto.com/est/et-EE/">Konfiguraator</a>
              </li>
              <li
                id="menu-item-20731"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-20731"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/makseviisid/">
                  Makseviisid
                </a>
              </li>
              <li
                id="menu-item-20730"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-20730"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/kindlustus/">Kindlustus</a>
              </li>
              <li
                id="menu-item-3836"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-3836"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/uudised/">Uudised</a>
              </li>
              <li
                id="menu-item-19635"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19635"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/?page_id=5194">
                  Koostööprojektid
                </a>
              </li>
              <li
                id="menu-item-3889"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-3889"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/privaatsuspoliitika/">
                  Privaatsustingimused
                </a>
              </li>
              <li
                id="menu-item-19634"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19634"
                role="treeitem"
              >
                <a href="https://www.skodalaagri.ee/arikliendile/">
                  Ärikliendile
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </nav>
    );
  }
}
